module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-34-2064a7353206354d2a12e63144180c4a.svg";